import type { MapFeatureCollection, HeatmapFeatureCollection } from "@atlas/shared";
import { apiGet } from "../lib/api-client";
import type { EquippedCosmeticItem } from "./profile";

// Showcase — the public full-screen map of everything a user has completed.
// Data is served sig-gated by GET /share/showcase (no session); the permanent
// link itself is minted for the owner by GET /map/showcase-url.

export interface ShowcaseResponse {
  owner: { name: string | null; username: string | null };
  features: MapFeatureCollection;
  heatmap: HeatmapFeatureCollection;
  equipped: {
    mapTheme: EquippedCosmeticItem | null;
    traceStyle: EquippedCosmeticItem | null;
    pin: EquippedCosmeticItem | null;
  };
}

export function fetchShowcase(userId: string, sig: string): Promise<ShowcaseResponse> {
  const params = new URLSearchParams({ u: userId, sig });
  return apiGet(`/share/showcase?${params}`);
}

export function fetchShowcaseUrl(): Promise<{ url: string }> {
  return apiGet("/map/showcase-url");
}

// The owner's own showcase, embedded inside the app (dashboard panel): mint
// the permanent link, then load the exact dataset the public page serves so
// the embed and the full-screen view can never drift apart.
export interface OwnShowcase {
  url: string;
  data: ShowcaseResponse;
}

export async function fetchOwnShowcase(): Promise<OwnShowcase> {
  const { url } = await fetchShowcaseUrl();
  const params = new URL(url).searchParams;
  const data = await fetchShowcase(params.get("u")!, params.get("sig")!);
  return { url, data };
}
